import type { DocumentReference, Timestamp } from 'firebase/firestore'
import { collection, query, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'

export const collectionDeliversLocation = collection(
  firestore,
  'deliversLocation',
)

export function getDeliverLocation(deliverRef: DocumentReference, companyRef: DocumentReference, dateFrom: Timestamp, dateTo: Timestamp) {
  return query(
    collectionDeliversLocation,
    where('deliver', '==', deliverRef),
    where('company', '==', companyRef),
    where('date', '>=', dateFrom),
    where('date', '<=', dateTo),
  )
}
